import orare from '../images/covers/albums/orare.jpg'
import aold from '../images/covers/albums/aold.jpg'
import snowOcean from '../images/covers/albums/snow-ocean.jpg'
import lcyhm from '../images/covers/albums/lcyhm.png'
import nfa from '../images/covers/albums/nfa.jpg'

export const albumRoutes = [
    {
        title: "Orare",
        img: orare,
        spotify: "https://open.spotify.com/album/3ARnppCqDsz9YRAxWjxOIV?si=Kyll7UKLRt-jg5OlPYIxfQ",
        apple: "https://music.apple.com/us/album/orare/1472209892",
        soundcloud: "https://soundcloud.com/spinyoungplanet/sets/orare"
    },
    {
        title: "All Our Lives Dreaming",
        img: aold,
        spotify: "https://open.spotify.com/album/78ZIqjrrrZpRfr8iE0phTm",
        apple: "https://music.apple.com/us/album/all-our-lives-dreaming-single/1136073332",
        soundcloud: "https://soundcloud.com/spinyoungplanet/sets/all-our-lives-dreaming"
    },
    {
        title: "New Fast Automatic",
        img: nfa,
        spotify: "https://open.spotify.com/album/4Cu7DRV91hM8jsdennnLKG?si=OV_YctnaTUG2Q6TrQUocTQ",
        apple: "https://music.apple.com/us/album/new-fast-automatic/1286930847",
        soundcloud: "https://soundcloud.com/spinyoungplanet/sets/new-fast-automatic"
    },
    {
        title: "Snow Ocean",
        img: snowOcean,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/sets/snowocean"
    },
    {
        title: "Ludwig Can You Hear Me?",
        img: lcyhm,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/sets/ludwig-can-you-hear-me"
    },
]